import { lazy } from "react";
import HTTPRequest from "../Utils/HTTPRequest";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import Expand from "@arcgis/core/widgets/Expand";
import Basemap from "@arcgis/core/Basemap";
import Bookmarks from "@arcgis/core/widgets/Bookmarks";
import Legend from "@arcgis/core/widgets/Legend";
import Fullscreen from "@arcgis/core/widgets/Fullscreen";
import Home from "@arcgis/core/widgets/Home";
import Portal from "@arcgis/core/portal/Portal";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import PortalBasemapsSource from "@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource";
import i18next, { changeLanguage } from "i18next";
import Extent from "@arcgis/core/geometry/Extent";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import LayerList from "@arcgis/core/widgets/LayerList";
import Print from "@arcgis/core/widgets/Print";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Search from "@arcgis/core/widgets/Search";

const CommonFunctions = {
  InitializeViewEvents(view, that, layer) {
    /* when user clicks on graphic highlight the feature on gallery and left side */
    view.on("click", (event) => {
      view.popup.fetchFeatures(event.screenPoint).then(function (response) {
        //Access the response from fetchFeatures
        response.allGraphicsPromise.then(function (graphics) {
          //Set the feature widget's graphic to the returned graphic from fetchFeatures
          if (typeof graphics != "undefined") {
            layer.graphics.remove();

            var markerSymbol = {
              type: "picture-marker",
              url: "images/top20.gif",
              width: 38,
              height: 38,
            };
            graphics[0].symbol = markerSymbol;
            var id = graphics[0].attributes.id - 1;
            that.setState({ activeIndex: id });
          }
        });
      });
    });

    /*show the info window when mouse hover on the feature */
    view.on("pointer-move", function (event) {
      view.hitTest(event).then(function (response) {
        if (response.results.length) {
          var graphic = response.results[0].graphic;
          if (typeof graphic != "undefined") {
            if (graphic.geometry != null) {
              view.popup.open({
                location: graphic.geometry,
                features: [graphic],
              });
            } else {
              view.popup.close();
            }
          } else {
            view.popup.close();
          }
        } else {
          view.popup.close();
        }
      });
    });
  },
  lazyWithRetry(componentImport) {
    return lazy(async () => {
      const pageHasAlreadyBeenForceRefreshed = JSON.parse(
        window.localStorage.getItem("page-has-been-force-refreshed") || "false"
      );

      try {
        const component = await componentImport();

        window.localStorage.setItem("page-has-been-force-refreshed", "false");

        return component;
      } catch (error) {
        if (!pageHasAlreadyBeenForceRefreshed) {
          // Assuming that the user is not on the latest version of the application.
          // Let's refresh the page immediately.
          window.localStorage.setItem("page-has-been-force-refreshed", "true");
          return window.location.reload();
        }

        // The page has already been reloaded
        // Assuming that user is already using the latest version of the application.
        // Let's let the application crash and raise the error.
        throw error;
      }
    });
  },
  renderAppConfig(SubThemesInfo, ThemeConfig) {
    this.appConfig = {};
    let language = sessionStorage.getItem("language");

    var subTheme = (this.appConfig[
      SubThemesInfo[0].SubThemeName.toLocaleLowerCase()
    ] = {});
    subTheme["cmsPageId"] =
      language == "ar"
        ? SubThemesInfo[0].CmsPageId_ar
        : SubThemesInfo[0].CmsPageId;
    subTheme["Title"] = SubThemesInfo[0].Title;
    subTheme["Title_ar"] = SubThemesInfo[0].Title_ar;
    for (let k = 0; k < ThemeConfig.length; k++) {
      if (
        ThemeConfig[k].SubThemeName.toLowerCase() ==
        SubThemesInfo[0].SubThemeName.toLowerCase()
      ) {
        subTheme["activeindex"] = k;
      }
    }
    var subarr = [];

    for (var i = 0; i < SubThemesInfo.length; i++) {
      var subSection;
      //if SubSectionName is null or empty
      if (
        SubThemesInfo[i].SubSectionName != null &&
        SubThemesInfo[i].SubSectionName != ""
      ) {
        var section;
        let index = subarr.indexOf(SubThemesInfo[i].SectionName);
        //if the SectionName doesn't already exist in subTheme object then we create a key in it.
        //section becomes an object in subTheme
        if (index == -1) {
          section = subTheme[SubThemesInfo[i].SectionName] = {};
          section["mapDivId"] = SubThemesInfo[i].MapDivId;
          section["name"] = SubThemesInfo[i].SectionName;
          subarr.push(SubThemesInfo[i].SectionName);
        } else {
          //if the SectionName already exists in subTheme object then we access it.
          section = subTheme[SubThemesInfo[i].SectionName];
        }
        //then we create a SubSectionName key inside the Section and SubSectionName becomes and object inside section
        subSection = section[SubThemesInfo[i].SubSectionName] = {};
        subSection["tabcls"] = SubThemesInfo[i].SectionName;
        subSection["sectionname"] = SubThemesInfo[i].UniqueIdentifier;
        subSection["title"] =
          language == "ar"
            ? SubThemesInfo[i].ItemTitle_ar
            : SubThemesInfo[i].ItemTitle;
        subSection["name"] =
          language == "ar"
            ? SubThemesInfo[i].ItemName_ar
            : SubThemesInfo[i].ItemName;
      } else {
        subSection = subTheme[SubThemesInfo[i].SectionName] = {};
        subSection["mapDivId"] = SubThemesInfo[i].MapDivId;
        //if the SubSectionName was null then name of subSection will be UniqueIdentifier
        subSection["name"] =
          language == "ar"
            ? SubThemesInfo[i].UniqueIdentifier
            : SubThemesInfo[i].UniqueIdentifier;
      }
      subSection["mapType"] = SubThemesInfo[i].ComponentType;
      subSection["ShowBasemap"] = SubThemesInfo[i].ShowBasemap;
      subSection["ShowToc"] = SubThemesInfo[i].ShowToc;
      subSection["ShowMapScale"] = SubThemesInfo[i].ShowMapScale;
      subSection["ShowPrint"] = SubThemesInfo[i].ShowPrint;
      subSection["ShowOverView"] = SubThemesInfo[i].ShowOverView;
      subSection["ShowSearch"] = SubThemesInfo[i].ShowSearch;
      subSection["ShowLegend"] = SubThemesInfo[i].ShowLegend;
      subSection["SeachFields"] =
        language == "ar"
          ? SubThemesInfo[i].SEARCH_FIELDS_AR
          : SubThemesInfo[i].SEARCH_FIELDS;
      subSection["SeachUrl"] = SubThemesInfo[i].SEARCH_URL;
      subSection["DisplayFields"] =
        language == "ar"
          ? SubThemesInfo[i].DISPLAY_FIELD_AR
          : SubThemesInfo[i].DISPLAY_FIELD;
      subSection["PlaceHolder"] =
        language == "ar"
          ? SubThemesInfo[i].PLACEHOLDER_NAME_AR
          : SubThemesInfo[i].PLACEHOLDER_NAME;
      subSection["SearchResultsTitle"] =
        language == "ar" ? SubThemesInfo[i].NAME_AR : SubThemesInfo[i].NAME;

      //feature config start
      if (
        SubThemesInfo[i].ComponentType == "Map" ||
        SubThemesInfo[i].ComponentType == "StoryMapHorizontal" ||
        SubThemesInfo[i].ComponentType == "StoryMapVertical"
      ) {
        if (SubThemesInfo[i].ComponentType == "Map") {
          subSection["FeatureDisplayFieldsLabels"] =
            language == "ar"
              ? SubThemesInfo[i].DisplayFieldsLabels_ar
              : SubThemesInfo[i].DisplayFieldsLabels_en;
        } else {
          subSection["FeatureDisplayFieldsLabels"] =
            SubThemesInfo[i].DisplayFieldsLabels_en;
        }
        subSection["FeatureDisplayFields"] =
          language == "ar"
            ? SubThemesInfo[i].DisplayFields_ar
            : SubThemesInfo[i].DisplayFields_en;
        subSection["FeatureListViewFields"] =
          language == "ar"
            ? SubThemesInfo[i].ListViewFields_ar
            : SubThemesInfo[i].ListViewFields_en;
        subSection["FeatureTitle"] =
          language == "ar"
            ? SubThemesInfo[i].Title_ar1
            : SubThemesInfo[i].Title_en;
        subSection["FeatureQueryFields"] = SubThemesInfo[i].QueryFields;
        subSection["FeatureOrderbyField"] = SubThemesInfo[i].OrderbyField;
        subSection["FeatureSearchField"] = SubThemesInfo[i].QuerySearchField;
        subSection["FeatureOrderbyType"] = SubThemesInfo[i].OrderbyType;
        subSection["FeatureLayerTitle"] =
          language == "ar"
            ? SubThemesInfo[i].Layer_title_ar
            : SubThemesInfo[i].Layer_title;
      }
      //feature config end
      if (SubThemesInfo[i].ComponentType == "SwipeWidget") {
        subSection["LeadingLayer"] =
          language == "ar"
            ? SubThemesInfo[i].LeadingLayer_ar
            : SubThemesInfo[i].LeadingLayer_en;
        subSection["TrailingLayer"] =
          language == "ar"
            ? SubThemesInfo[i].TrailingLayer_ar
            : SubThemesInfo[i].TrailingLayer_en;
        subSection["Center"] = SubThemesInfo[i].Center;
        subSection["BMUrl"] = SubThemesInfo[i].BMUrl;
        subSection["MaxScale"] = SubThemesInfo[i].MaxScale;
      }
      subSection["source"] = this.GetSourceDetails(SubThemesInfo[i], language);
      subSection["sourceForExcel"] = this.GetSourceDetails(
        SubThemesInfo[i],
        language,
        true
      );
      if (
        SubThemesInfo[i].MapType == "Dashboard" ||
        SubThemesInfo[i].MapType == "Chart" ||
        SubThemesInfo[i].MapType == "LineChart"
      ) {
        subSection["dashboardurl"] =
          language == "ar"
            ? SubThemesInfo[i].PortalUrl_ar
            : SubThemesInfo[i].PortalUrl;
      } else {
        subSection["mapId"] = i;
        var mapSettings = (subSection["mapSettings"] = {});
        var portal = (mapSettings["portal"] = {});
        portal["url"] =
          language == "ar"
            ? SubThemesInfo[i].PortalUrl_ar
            : SubThemesInfo[i].PortalUrl;
        portal["portalItemId"] =
          language == "ar"
            ? SubThemesInfo[i].PortalItemId_ar
            : SubThemesInfo[i].PortalItemId;
        portal["basemapurl"] =
          language == "ar"
            ? SubThemesInfo[i].BaseMapUrl_ar
            : SubThemesInfo[i].BaseMapUrl;
        portal["minZoom"] = SubThemesInfo[i].MinZoom;
        portal["maxZoom"] = SubThemesInfo[i].MaxZoom;
        portal["isPan"] = SubThemesInfo[i].isPan;
        portal["zoomLevel"] = SubThemesInfo[i].zoomlevel;
        portal["referenceLayer"] =
          language == "ar"
            ? SubThemesInfo[i].ReferenceLayer_ar
            : SubThemesInfo[i].ReferenceLayer_en;
      }
    }
    console.log("appConfig: ", this.appConfig);
    return this.appConfig;
  },
  renderColors() {
    var colors = [];
    let pathname = window.location.pathname;
    let patharray = pathname.split("/");
    let theme = null;
    if (patharray.length > 2 && process.env.REACT_APP_BASE_URL == "") {
      theme = patharray[1];
    } else if (patharray.length > 3 && process.env.REACT_APP_BASE_URL != "") {
      theme = patharray[2];
    }
    if (theme != null) {
      theme = theme.toLowerCase();
      if (theme == "health") {
        colors = ["#5fd6de", "#5991cf", "#8d5a4d"];
      } else if (theme == "womenempowerment") {
        colors = ["#de8ba5", "#5fd6de"];
      } else if (theme == "environment") {
        colors = ["#5fd6de", "#5991cf"];
      } else if (theme == "youthempowerment") {
        colors = ["#693ca6", "#c295ff", "#a46af3"];
      } else if (theme == "education") {
        colors = [
          "#579BB2",
          "#57C7EC",
          "#289EC9",
          "#47BBE6",
          "#5AAEE6",
          "#2C8CD5",
          "#579DDF",
          "#3198BA",
          "#52AFCE",
        ];
      } else if (theme == "population") {
        colors = [
          "#5491c2",
          "#92c9f6",
          "#6993b5",
          "#4f83ae",
          "#88c2f1",
          "#61a7e1",
          "#95c0e6",
          "#5793c4",
          "#5687b0",
          "#679dc9",
          "#6d8eaa",
        ];
      } else if (theme == "economy") {
        colors = [
          "#bcb260",
          "#d5c971",
          "#bdb25a",
          "#c7be7a",
          "#9b9143",
          "#dcd39a",
          "#d1c250",
          "#dacc60",
          "#aca258",
          "#9f933b",
        ];
      } else if (theme == "infrastructure") {
        colors = [
          "#174fa7",
          "#2d76e7",
          "#6595e2",
          "#5a67dc",
          "#2566ce",
          "#2672ec",
          "#288fdd",
          "#4389cb",
          "#247cb6",
          "#1d489a",
        ];
      } else if (theme == "energy") {
        colors = [
          "#ffe052",
          "#c1a115",
          "#f0d976",
          "#f1ca1c",
          "#d5b529",
          "#f0e5ae",
          "#eede97",
          "#f3d656",
          "#dfb600",
          "#ddc144",
        ];
      } else if (theme == "regionalandinternationalcontext") {
        colors = [
          "#8d5a4d",
          "#df9582",
          "#d86d52",
          "#ae4c33",
          "#a4786d",
          "#d89e91",
          "#8a5e52",
          "#80362b",
          "#9a5544",
          "#c1a199",
        ];
      } else if (theme == "smartcities") {
        colors = ["#8d5a4d"];
      }
    }
    return colors;
  },
  GetSourceDetails(result, language, forExcel) {
    var source = " ";
    var datasource =
      language == "ar" ? result.Data_Source_Ar : result.Data_Source;
    var sourceurl = language == "ar" ? result.Source_URL_Ar : result.Source_URL;
    var shorturl = language == "ar" ? result.Short_URL_Ar : result.Short_URL;
    var LastUpdateDate = result.LastUpdatedDate;
    if (result.IsOpenData == null) {
      source = language == "ar" ? result.Source_ar : result.Source;
    } else {
      if (result.IsOpenData == "Yes") {
        source = source + i18next.t("OpenData") + datasource;
      }
      if (result.IsOpenData == "No") {
        source = source + datasource;
      }
      if (sourceurl != null && sourceurl != "" && !forExcel) {
        /*  var sourceurls= sourceurl.split(',');
            var shorturls=shorturls.split(',');
            if(sourceurls.length > 1)
            {
                for(var i=0;i<sourceurls.length;i++)
                {
                  source=source+", <a  href='"+ sourceurls[i]+"' target='_blank'> "+shorturls[i] +"</a>";
                }
            }
            else
            { */
        source =
          source +
          ", <a  href='" +
          sourceurl +
          "' target='_blank'> " +
          shorturl +
          "</a>";
        /*  } */
      }
      if (LastUpdateDate != null && LastUpdateDate != "") {
        source = source + ", " + i18next.t("LastUpdate") + LastUpdateDate;
      }
    }

    return source;
  },
  RenderRoundedData(labelValue) {
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? Math.round((Math.abs(Number(labelValue)) / 1.0e9) * 100) / 100 +
          i18next.t("B")
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e5
      ? Math.round((Math.abs(Number(labelValue)) / 1.0e6) * 100) / 100 +
        i18next.t("M")
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? Math.round((Math.abs(Number(labelValue)) / 1.0e3) * 100) / 100 +
        i18next.t("K")
      : Number(labelValue);
  },
  renderSubThemes(source) {
    var images = [];
    let language = sessionStorage.getItem("language");

    var result = source;
    if (result.length == 0) {
    }

    for (var i = 0; i < result.length; i++) {
      if (language === "ar")
        images.push({
          itemImageSrc: "/images/" + result[i].ImageUrl,
          href: "/" + result[i].ThemeName + "/" + result[i].SubThemeName,
          alt: result[i].SubThemeName,
          title: result[i].Title_ar,
          NoOfItemsToDisplay: result[i].NoOfItemsToDisplay,
          ThemeTitle: result[i].ThemeTitle_ar,
          ThemeName: result[i].ThemeName,
          id: i + 1,
          BackgroundImageUrl:
            process.env.REACT_APP_BASE_URL +
            "/images/" +
            result[i].BackgroundImageUrl,
        });
      else
        images.push({
          itemImageSrc: "/images/" + result[i].ImageUrl,
          href: "/" + result[i].ThemeName + "/" + result[i].SubThemeName,
          alt: result[i].SubThemeName,
          title: result[i].Title,
          NoOfItemsToDisplay: result[i].NoOfItemsToDisplay,
          ThemeTitle: result[i].ThemeTitle,
          ThemeName: result[i].ThemeName,
          id: i + 1,
          BackgroundImageUrl:
            process.env.REACT_APP_BASE_URL +
            "/images/" +
            result[i].BackgroundImageUrl,
        });
    }
    return images;
  },
  renderThemesInfo(source) {
    var ThemesInfo = [];
    let language = sessionStorage.getItem("language");

    var result = source;
    if (result.length == 0) {
      window.location.href = process.env.REACT_APP_BASE_URL + "/404";
    }

    for (var i = 0; i < result.length; i++) {
      var ThemeClass = result[i].ThumbnailImageUrl.split(".jpg");
      ThemesInfo.push({
        ThemeName: result[i].ThemeName,
        ThemeTitle:
          language === "ar" ? result[i].ThemeTitle_ar : result[i].ThemeTitle,
        href: "/" + result[i].NavigationUrl,
        image: "images/" + result[i].ThumbnailImageUrl,
        mobileImageUrl: "images/" + result[i].mobileImageUrl,
        ThemeClass: ThemeClass[0],
      });
    }
    return ThemesInfo;
  },
  getSelectedLanguage() {
    const lang = new URLSearchParams(window.location.search).get("lang");
    const validLang = lang === "en" || lang === "ar" ? lang : null;

    sessionStorage.setItem(
      "language",
      validLang || sessionStorage.getItem("language") || "ar"
    );

    return sessionStorage.getItem("language");
  },

  changeLanguage(e) {
    var lng = e.currentTarget.innerText;
    let newLang = lng === ("ENGLISH" || "ENG") ? "en" : "ar";
    sessionStorage.setItem("language", newLang);

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (params.get("lang")) {
      params.set("lang", newLang);
      url.search = params.toString();
    }
    window.location.href = url.toString();
  },

  // start login open for public
  getSession() {
    return true;
    // return sessionStorage.getItem("session") == null
    //   ? false
    //   : sessionStorage.getItem("session");
  },
  // end login open for public
  renderBaseMapGallery(view, position) {
    var language = this.getSelectedLanguage();
    if (typeof position == "undefined") {
      position = "top-left";
    }
    var source = "basemapconfigen";
    if (language === "ar") source = "basemapconfigar";

    HTTPRequest.getJson(
      process.env.REACT_APP_AtlasWSurl + "GetChartData?source=" + source,
      false,
      function (result) {
        const portal = new Portal({
          url: process.env.REACT_APP_portalUrl,
        });

        var portalItems = [];

        const source = new PortalBasemapsSource({
          portal,
          updateBasemapsCallback: function (items) {
            for (var i = 0; i < items.length; i++) {
              for (var j = 0; j < result.length; j++) {
                if (items[i].portalItem.id === result[j].portalitemid) {
                  portalItems.push(items[i]);
                }
              }
            }
            //console.log(portalItems);
            return portalItems;
          },
        });

        let basemapGallery = new BasemapGallery({
          view: view,
          source: source,
        });

        let bgExpand = new Expand({
          view,
          content: basemapGallery,
          expandIconClass: "esri-icon-basemap",
          //collapseIconClass: "esri-icon-collapse",
          expandTooltip: i18next.t("Basemapgallery"),
        });
        view.ui.add(bgExpand, position);
        basemapGallery.watch(
          "activeBasemap",
          function (newValue, oldValue, property, object) {
            if (bgExpand != undefined && bgExpand != null) {
              bgExpand.expanded = false;
            }
          }
        );
      }
    );
  },
  renderBookMarkWidget(view) {
    const bookmarks = new Bookmarks({
      view: view,
      editingEnabled: false,
    });
    const legend = new Expand({
      content: bookmarks,
      view: view,
      expanded: false,
    });

    view.ui.add(legend, "top-left");
    return legend;
  },
  renderHomeButtonWidget(view, applicationDiv) {
    view.ui.add(
      new Home({
        view: view,
      }),
      "top-right"
    );
  },
  renderFullScreenWidget(view, applicationDiv) {
    view.ui.add(
      new Fullscreen({
        view: view,
        element: applicationDiv,
      }),
      "top-right"
    );
  },
  renderLegendWidget(view, Istocavailable) {
    var legendlayerlist = true;

    if (isMobile) {
      legendlayerlist = false;
    }

    const legend = new Expand({
      content: new Legend({
        view: view,
        listItemCreatedFunction: (event) => {
          const item = event.item;
          if (item.layer.type != "group") {
            // don't show legend twice
            item.panel = {
              content: "legend",
              open: true,
            };
          }
        },
      }),
      view: view,
      expandTooltip: i18next.t("Legend"),
      expanded: legendlayerlist,
    });

    view.ui.add(legend, "top-left");
    return legend;
  },
  renderPlaybutton(param) {
    var elementgalleria = document.getElementById(param);
    if (
      elementgalleria !== null &&
      document.getElementById(param + "playdiv") === null
    ) {
      var element = elementgalleria.getElementsByClassName(
        "p-galleria-thumbnail-wrapper"
      );

      //Create the element using the createElement method.
      var myDiv = document.createElement("div");

      //Set its unique ID.
      myDiv.id = param + "playdiv";

      //Add your content to the DIV
      myDiv.innerHTML =
        "<button id=" +
        param +
        'playbtn  class="p-button p-component carousel-pause play play_onlytitle p-button-icon-only"><span class="p-button-icon p-c pi pi-play" id=' +
        param +
        "playspan></span></button>";
      //Finally, append the element to the HTML body
      element[0].appendChild(myDiv);
    }
  },
  renderThemeName() {
    let pathname = window.location.pathname;
    let patharray = pathname.split("/");
    let theme = null;
    if (patharray.length > 2 && process.env.REACT_APP_BASE_URL === "") {
      theme = patharray[1].toLocaleLowerCase();
    } else if (patharray.length > 3 && process.env.REACT_APP_BASE_URL !== "") {
      theme = patharray[2].toLocaleLowerCase();
    }
    return theme;
  },
  responsiveOptions(param) {
    return [
      {
        breakpoint: "1400px",
        numVisible: param >= 4 ? 4 : 3,
      },
      {
        breakpoint: "1024px",
        numVisible: 3,
      },
      {
        breakpoint: "768px",
        numVisible: 2,
      },
      {
        breakpoint: "560px",
        numVisible: 1,
      },
    ];
  },
  Scrolltoview(ID, GID) {
    let section;
    if (GID != undefined) {
      section = document.querySelector("#" + GID).parentElement.parentElement;
    } else {
      section = document.querySelector("#" + ID);
    }
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  },
  SetMinMaxZoom(view, minZoom, maxZoom) {
    var mq = window.matchMedia("screen and (min-width: 1601px)");

    if (isMobile == false) {
      if (mq.matches) {
        if (minZoom != null) view.constraints.minZoom = minZoom;
      } else {
        if (minZoom != null) view.constraints.minZoom = minZoom - 1;
      }
    }
    //for mobile
    else {
      if (minZoom != null) view.constraints.minZoom = minZoom - 2;
    }

    if (maxZoom != null) view.constraints.maxZoom = maxZoom;
  },
  addReferenceLayer(LayerURL, map) {
    if (LayerURL != null && LayerURL != "") {
      var Basemap_VectorLayer = new VectorTileLayer({
        url: LayerURL,
      });
      map.add(Basemap_VectorLayer);
    }
  },
  renderMapScale(view) {
    let scaleBar = new ScaleBar({
      view: view,
      unit: "metric",
    });
    // Add widget to the bottom left corner of the view
    view.ui.add(scaleBar, {
      position: "bottom-left",
    });
  },
  renderPrint(view) {
    const print = new Print({
      view: view,
      // specify your own print service
      printServiceUrl: process.env.REACT_APP_PrintUrl,
      //"https://webgislab.fgic.gov.ae/hosting/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
    });

    const printExpand = new Expand({
      expandIconClass: "esri-icon-printer", // see https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/
      expandTooltip: i18next.t("Print"), // optional, defaults to "Expand" for English locale
      view: view,
      content: print,
    });

    // Add widget to the top right corner of the view
    view.ui.add(printExpand, "top-left");
    return printExpand;
  },
  createBaseMap(basemapUrl) {
    let basemap = new Basemap({
      baseLayers: [
        new VectorTileLayer({
          url: basemapUrl,
          title: "Basemap",
        }),
      ],
      title: "basemap",
      id: "basemap",
    });
    return basemap;
  },
  createBaseMapByPortalItemId() {
    let id =
      this.getSelectedLanguage() == "ar"
        ? process.env.REACT_APP_BASEMap_AR_ID
        : process.env.REACT_APP_BASEMap_EN_ID;
    let basemap = new Basemap({
      portalItem: {
        id: id, // WGS84 Streets Vector webmap
      },
    });
    return basemap;
  },
  renderSearchWidget(view, props) {
    props.PlaceHolder = props.PlaceHolder == null ? "" : props.PlaceHolder;
    props.SearchResultsTitle =
      props.SearchResultsTitle == null ? "" : props.SearchResultsTitle;
    props.ZOOMLEVEL = props.ZOOMLEVEL == null ? "" : props.ZOOMLEVEL;
    let Sources = [];
    let SeachUrl = props.SeachUrl.split(",");
    let SeachFields = props.SeachFields.split("|");
    let DisplayFields = props.DisplayFields.split(",");
    let PlaceHolder = props.PlaceHolder.split(",");
    let ZOOMLEVEL = props.ZOOMLEVEL.split(",");
    let SearchResultsTitle = props.SearchResultsTitle.split(",");
    for (var i = 0; i < SeachUrl.length; i++) {
      if (
        SeachUrl.length == SeachFields.length &&
        SeachUrl.length == DisplayFields.length
      ) {
        /* const featureLayerDistricts = new FeatureLayer({
            url: "https://webgislab.fgic.gov.ae/hosting/rest/services/Atlas_Health_Theme/HT_SL3_COVID_EN/MapServer/1",
           
          }); */
        Sources.push({
          layer: new FeatureLayer({ url: SeachUrl[i] }),
          searchFields: SeachFields[i].split(","),
          displayField: DisplayFields[i],
          exactMatch: false,
          outFields: ["*"],
          maxResults: 1000,
          ZOOMLEVEL: ZOOMLEVEL,
          name:
            SearchResultsTitle.length > 1
              ? SearchResultsTitle[i]
              : SearchResultsTitle[0],
          placeholder: PlaceHolder.length > 1 ? PlaceHolder[i] : PlaceHolder[0],
        });
      }
    }

    if (Sources.length == 0) {
      return;
    }
    const searchWidget = new Search({
      view: view,
      //allPlaceholder: "District or Senator",
      includeDefaultSources: false,
      sources: Sources,
    });

    // Add the search widget to the top left corner of the view
    view.ui.add(searchWidget, {
      position: "top-right",
    });
  },
  renderLayerList(view, Istocavailable) {
    var isopen = true;
    /* if(Istocavailable){
      isopen=true;
    } */
    if (isMobile) {
      isopen = false;
    }
    let layerList = new LayerList({
      view: view,
    });
    const layerlistExpand = new Expand({
      expandIconClass: "esri-icon-layers",
      expandTooltip: i18next.t("Toc"),
      view: view,
      content: layerList,
      expanded: isopen,
    });
    // Adds widget below other elements in the top left corner of the view
    view.ui.add(layerlistExpand, {
      position: "top-right",
    });

    return layerlistExpand;
  },
  setExtent() {
    /* const extent = new Extent({
      xmin: 51.256714,
      ymin: 22.271306,
      xmax: 56.596069,
      ymax: 26.409091,
      spatialReference: new SpatialReference({ wkid: 4326 }),
    }); */

    /* const extent = new Extent({
      xmin: 51.456868 ,
      ymin: 22.435889,
      xmax: 56.587483,
      ymax: 26.504477,
      spatialReference: new SpatialReference({ wkid: 4326 }),
    }); */

    const extent = new Extent({
      xmax: 6462104.289443189,
      xmin: 5669605.1801826935,
      ymax: 3039889.869207193,
      ymin: 2511557.129700195,
      spatialReference: new SpatialReference({ wkid: 3857 }),
    });
    return extent;
    //return null;
  },
};

export default CommonFunctions;
